import React from "react"
import tw, { styled } from "twin.macro"

import MoreLink from "components/more-link"
import LinkTo from "components/link-to"
import MenuGroup from "components/header/menu-group"
import MenuTitle from "components/header/menu-title"
import MenuItems from "components/header/menu-items"

const ProductsMenuStyles = styled.div`
  ${tw`h-full`}

  transition: opacity 0.2 ease, height 0.5 ease-out;
  background: linear-gradient(180deg, #0f0f0f 0%, #1e1e1e 100%);
`

const ProductsMenu = ({ products }) => {
  return (
    <ProductsMenuStyles>
      <div className="flex flex-row items-between pt-8 px-2 w-full font-body text-white l:max-w-l mx-auto h-full">
        {products.map((menu) => (
          <MenuGroup key={menu.id} className="w-1/5">
            <LinkTo linkInfo={menu}>
              <MenuTitle className="product">
                <MoreLink product={true}>{menu.title}</MoreLink>
              </MenuTitle>
            </LinkTo>
            <MenuItems menu={menu} className="product"></MenuItems>
          </MenuGroup>
        ))}
      </div>
    </ProductsMenuStyles>
  )
}

export default ProductsMenu
